import { PageAboutSystemView } from './page-about-system.view'

function PageAboutSystem() {
  return (
    <PageAboutSystemView/>
  )
}

export { PageAboutSystem }
